import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BsChevronDown } from "react-icons/bs";
import "../Pages/WebBuilderFAQs.css";

function Faqs() {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    fetch("/faqs.json")
      .then((res) => res.json())
      .then((data) => {
        const mapsCategory = (data.faqs || []).find((c) => c.category === "MAPS");
        const items = (mapsCategory?.items || []).slice(0, 3);
        setFaqData(items);
      })
      .catch(() => setFaqData([]));
  }, []);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <section id="faq" className="ptb-100 gray-light-bg pharmacy-faq-section">
      <div className="container">
        <div className="wb-faq-section">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="section-heading text-center mb-4">
                <h2 className="web">Frequently Asked Questions</h2>
              </div>
            </div>
          </div>
          <div className="row align-items-start g-4 g-lg-5 mt-2">
            <div className="col-lg-7 col-12">
              <div className="wb-faq-layout wb-faq-layout-modern">
                {faqData.map((item, index) => (
                  <div
                    key={index}
                    className={`wb-faq-item ${activeAccordion === index ? "is-open" : ""}`}
                  >
                    <button
                      type="button"
                      className="wb-faq-trigger"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={activeAccordion === index}
                    >
                      <span className="wb-faq-question">{item.question}</span>
                      <span className="wb-faq-chevron" aria-hidden="true">
                        <BsChevronDown size={14} />
                      </span>
                    </button>
                    <div className="wb-faq-content">
                      <div className="wb-faq-body">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-5 col-12">
              <div className="wb-faq-cta">
                <h3 className="wb-faq-cta-title">Still have questions?</h3>
                <p className="wb-faq-cta-text">
                  Request a demo to see ClinTa MAPS in action, or explore our full FAQ library for more answers.
                </p>
                <div className="wb-faq-cta-btns">
                  <Link to="/request-a-demo?product=MAPS" className="wb-faq-cta-btn wb-faq-cta-btn-primary">
                    Request a demo
                  </Link>
                  <Link to="/faqs?category=MAPS" className="wb-faq-cta-btn wb-faq-cta-btn-outline">
                    View all FAQs
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faqs;
